<script>
export default {
  name: 'InfoBlock',
  props: {
    label: {
      type: String,
      default: 'Title',
    },
    data: {
      type: String,
      default: 'Title',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<template>
  <div class="staking-card main-block">
    <p class="label">{{ label }}</p>
    <p class="data">{{ data }}</p>
    <div class="ul" v-if="list.length">
      <div class="li" v-for="(l, key) in list" :key="key">
        <span>{{ l }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.staking-card {
  padding: 2.8rem 3.2rem 2.9rem 3.2rem;

  p {
    margin-bottom: 1.5rem;
  }

  .ul {
    margin-top: -1rem;
    display: flex;
    flex-direction: column;

    .li {
      font-size: 1.4rem;
      margin-bottom: 0.8rem;
      font-weight: 600;
    }
  }

  .label {
    font-size: 1.8rem;
    font-weight: 600;
  }

  .data {
    font-size: 2.8rem;
    font-weight: 600;
  }

  &--inline {
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      margin-bottom: 0;
    }
  }
}
</style>
